export const routes = [
  {
    path: '/:path(.*)',
    name: 'index',
    component: () => import('/Users/xinyu/.jenkins/workspace/vite-commonality-prod/common/oxygen/oxygenSoul/pages/index.vue'),
    /* no children */
  },
  {
    path: '/record',
    name: 'record',
    component: () => import('/Users/xinyu/.jenkins/workspace/vite-commonality-prod/common/oxygen/oxygenSoul/pages/record.vue'),
    /* no children */
    meta: {
      "title": "兑换记录"
    }
  },
  {
    path: '/transferRecord',
    name: 'transferRecord',
    component: () => import('/Users/xinyu/.jenkins/workspace/vite-commonality-prod/common/oxygen/oxygenSoul/pages/transferRecord.vue'),
    /* no children */
    meta: {
      "title": "转赠记录"
    }
  }
]
